import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Twitter as TwitterIcon, Telegram as TelegramIcon } from '@mui/icons-material';
import { trackLandingPageEvents } from '../utils/analytics';

const Footer = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        py: 4,
        borderTop: "1px solid #333",
        mt: 4
      }}
    >
      <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
        © 2024 MEME fr ($MFR) - Powered by memes, pixel by pixel.
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<TwitterIcon />}
          onClick={() => {
            trackLandingPageEvents.twitterClick();
            window.open("https://x.com/meme_for_real", "_blank");
          }}
          sx={{
            borderColor: "#00ff00",
            color: "#00ff00",
            "&:hover": {
              borderColor: "#00ff00",
              background: "rgba(0, 255, 0, 0.1)"
            }
          }}
        >
          Twitter
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<TelegramIcon />}
          onClick={() => {
            trackLandingPageEvents.telegramClick();
            window.open("https://t.me/memefr_community", "_blank");
          }}
          sx={{
            borderColor: "#00d4ff",
            color: "#00d4ff",
            "&:hover": {
              borderColor: "#00d4ff",
              background: "rgba(0, 212, 255, 0.1)"
            }
          }}
        >
          Telegram
        </Button>
      </Box>
    </Box>
  );
};

export default Footer;
